import React, { useImperativeHandle, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import AdministerBulkMedicationFormTemplate from "../templates/AdministerBulkMedicationFormTemplate";
import { useResidentMedicationsContext } from "../provider/ResidentMedicationsProvider";
import { AdministerBulkMedicationsProvider } from "../provider/AdministerBulkMedicationsProvider";

interface Ref {
  show: () => void;
  close: () => void;
}

const AdministerBulkMedicationModal = React.forwardRef<Ref, unknown>(
  (_, administerBulkRef) => {
    const [showing, setShowing] = useState(false);
    const { loadFrequencyFilters } = useResidentMedicationsContext();

    useImperativeHandle(administerBulkRef, () => ({
      show: () => {
        loadFrequencyFilters();
        setShowing(true);
      },
      close: handleClose,
    }));

    const handleClose = () => {
      setShowing(false);
    };

    return (
      <ReusableModal
        isVisible={showing}
        onClose={handleClose}
        className="w-full max-w-[984px] mx-auto"
        title="Administer Medication"
        hasCancelButton
        fullScreen
      >
        <AdministerBulkMedicationsProvider
          onFinishedBulkAdminister={handleClose}
        >
          <AdministerBulkMedicationFormTemplate
            onClose={handleClose}
          ></AdministerBulkMedicationFormTemplate>
        </AdministerBulkMedicationsProvider>
      </ReusableModal>
    );
  },
);

AdministerBulkMedicationModal.displayName = "AdministerBulkMedicationModal";
export { AdministerBulkMedicationModal };
